export const LEAD_GATE_COPY = {
  title: 'רוצים שנחבר אתכם ישירות למרצה?',
  supportingText: 'השאירו פרטים ונחזור אליכם תוך 24 שעות עם הפרטים על הקורס.',
  button: 'השאירו פרטים',
  successTitle: 'קיבלנו את הפרטים שלכם',
  successText: 'הבקשה התקבלה ואנחנו כבר מטפלים בה. נחזור אליכם תוך 24 שעות.',
} as const;
